import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/medical-history/comorbidities/nephrologicalAndUrologicalDiseases";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	nephrologicalAndUrologicalDiseases: {
		id: "form.nephrological_and_urological_diseases",
		defaultMessage: "Nephrológiai és urológiai betegségek"
	},
	comment: {
		id: "form.nephrological_and_urological_diseases.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.comment }] }]
};

export const node: LeafNode = {
	id: "nephrologicalAndUrologicalDiseases",
	value: {
		title: messages.nephrologicalAndUrologicalDiseases,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
